import React, {  } from "react";
import SponsorInfoContent from "./SponsorInfoContentEdit";

interface ContentProfileProps {
  data: any;
}
export const EditSponsorProfile = ({ data }: ContentProfileProps) => {
  return (
    <div className="takaful--content-profile">
      <div className="takaful--content-edit-profile-info">
        <div className="takaful--content-profile-title">
          <h1 style={{ marginBottom: "4rem" }}>البيانات الشخصية</h1>
        </div>
        <SponsorInfoContent infoArray={data} />
      </div>
    </div>
  );
};
